import React from 'react';
import { Box } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { SpacedChip } from './style';
import { PaidChipProps } from './types';

const PaidChip = ({ amount, changeReason }: PaidChipProps) => (
    <SpacedChip
        changeReason={changeReason}
        label={(
            <Box display='flex' alignItems='center'>
                {amount}
                <Box ml={.5}>
                    <ReceiptIcon color='primary' />
                </Box>
            </Box>
        )}
    />
);

export default PaidChip;
